import { StorageHandler } from "@lumen-developer/lumen-common-js";
import { store } from "../../../../store";
import Endpoint from "../../Endpoint";
import { VIEWABILITY_VERSION } from "../../../../types/types";

const getPayload = (nextButtonText) => {
  let {
    sessionId,
    studyId,
    cellId,
    showGaze,
    participantId,
    viewabilityVersion,
  } = store.getState().studyReducer;
  let { region } = store.getState().baseReducer;
  let { stepData } = store.getState().stepReducer;

  const viewabilityVersionString = (() => {
    switch (viewabilityVersion) {
      case VIEWABILITY_VERSION.EVENTS:
        return "events";
      case VIEWABILITY_VERSION.OBSERVER:
        return "observer";
      default:
        return "events";
    }
  })();

  let body = {
    sessionId: !!sessionId.toString ? sessionId.toString() : sessionId,
    study_id: studyId,
    cell_id: cellId,
    participant_id: participantId,
    show_gaze_points: !!showGaze ? showGaze : false,
    calibrationString:
      '{ "model": ' +
      StorageHandler.getItem("lr_model_data") +
      ', "ec": ' +
      StorageHandler.getItem("lr_errorcorrection_data") +
      "}",
    environment: process.env.REACT_APP_LUMEN_ENV_VALUE,
    step_data: stepData,
    region: region,
    nextButtonText: nextButtonText,
    viewability_version: viewabilityVersionString,
  };

  return body;
};

export default (nextButtonText) => {
  return new Endpoint(
    "save-calibration-data",
    `${process.env.REACT_APP_PARTICIPATION_URL}/ctt_calibration_data/save`,
    "POST",
    () => getPayload(nextButtonText),
    undefined,
    true,
  );
};
